import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import MovieCard from "./MovieCard";

export default function MovieRow({ title, description, icon, items, onSelect }) {
  const scrollRef = useRef(null);
  const scroll = (dir) => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollBy({ left: dir * 600, behavior: "smooth" });
  };

  return (
    <section className="max-w-[1500px] mx-auto px-6 mt-12 group/section">
      <div className="flex items-end justify-between mb-3">
        <div className="flex items-start gap-2">
          {icon}
          <div>
            <h2 className="text-2xl md:text-3xl font-bold tracking-tight">{title}</h2>
            <p className="text-red-500/85 mt-0.5 text-sm max-w-3xl">{description}</p>
          </div>
        </div>
        <div className="hidden md:flex gap-2">
          <button onClick={() => scroll(-1)} className="w-9 h-9 rounded-full bg-white/5 hover:bg-red-600/30 transition border border-white/10 flex items-center justify-center">
            <ChevronLeft className="w-5 h-5 text-white" />
          </button>
          <button onClick={() => scroll(1)} className="w-9 h-9 rounded-full bg-white/5 hover:bg-red-600/30 transition border border-white/10 flex items-center justify-center">
            <ChevronRight className="w-5 h-5 text-white" />
          </button>
        </div>
      </div>

      <div ref={scrollRef} className="no-scrollbar flex gap-4 overflow-x-auto pb-6 -mx-2 px-2 scroll-smooth">
        {items.map((it) => (
          <MovieCard key={it.id} item={it} onClick={() => onSelect(it)} />
        ))}
      </div>
    </section>
  );
}
